import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AnalysisPage from "../pages/analysis/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/analysis",
    element: <AnalysisPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;